(() => {
  if (window.GearfullProductCardLoaded) return;
  window.GearfullProductCardLoaded = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-gf-card-add]')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const errorElement = form.closest('.gf-card-actions').querySelector('.gf-card-add-error');
    errorElement.hidden = true;
    errorElement.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const drawer = document.querySelector('cart-drawer');
    let added = false;
    try {
      const body = new FormData(form);
      if (drawer) {
        body.set('sections', 'cart-drawer,cart-icon-bubble');
        body.set('sections_url', window.location.pathname);
        drawer.setActiveElement?.(button);
      }
      const response = await fetch(form.action + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || form.dataset.error);
      added = true;
      if (drawer && typeof drawer.renderContents === 'function' && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        document.dispatchEvent(new CustomEvent('gearfull:cart-updated', { detail: { cart: result } }));
      } else {
        window.location.assign(form.dataset.cartUrl);
      }
    } catch (error) {
      if (added) {
        window.location.assign(form.dataset.cartUrl);
      } else {
        errorElement.textContent = error.message || form.dataset.error;
        errorElement.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
